import { render, staticRenderFns } from "./QuillEditorField.vue?vue&type=template&id=144542e9&scoped=true"
import script from "./QuillEditorField.vue?vue&type=script&lang=ts"
export * from "./QuillEditorField.vue?vue&type=script&lang=ts"
import style0 from "./QuillEditorField.vue?vue&type=style&index=0&id=144542e9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144542e9",
  null
  
)

export default component.exports